export default "__VITE_ASSET__c7cecf1c__"